/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Prop Type
 */
export enum PropType {
    Automobile = 'Automobile',
    Trailer = 'Trailer',
    Motorcycle = 'Motorcycle',
    Skates = 'Skates',
    Skateboard = 'Skateboard',
    Bicycle = 'Bicycle',
    Moped = 'Moped',
    Camera = 'Camera',
    Pet = 'Pet',
    Footwear = 'Footwear',
    Luggage = 'Luggage',
    GolfClubs = 'Golf Clubs',
    GolfBag = 'GolfBag',
    TennisRacquet = 'Tennis Racquet',
    Skis = 'Skis',
    Binoculars = 'Binoculars',
    OperaGlasses = 'Opera Glasses',
    LargePortableRadio = 'Large Portable Radio',
    Book = 'Book',
    Laptop = 'Laptop',
    CellPhone = 'CellPhone',
    Tablet = 'Tablet',
    PDA = 'PDA',
    MP3Player = 'MP3 Player',
    Other = 'Other',
}
